import React from "react";
import { Subscription } from 'rxjs'
import './LoginDesktop.css'
import { LoginState } from "../../../states/LoginState";
import { Button, TextField } from "@material-ui/core";
import { StringUtils } from "../../../utils/StringUtils";
import Media from "react-media";
import { ReactComponent as HelpIcon } from "../../../resources/images/help.svg";
import { AuthService, LoginApiState } from "../../../services/authentication/AuthService";
import { RecaptchaProvider } from "../../../services/authentication/recaptcha-v3/RecaptchaProvider";
import { MposLoader } from "../../../components/loader/MposLoader";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import { ServiceUnavailablePage } from "../../service-unavailable-page/ServiceUnavailablePage";
import loginImage from '../../../resources/images/login_image_2.png';
import { ITerminalsDto } from "../../../models/TerminalsDto";
import { TerminalsUtils } from "../../../utils/TerminalsUtils";
import StateContextProvider from "../../../context/StateContext";

export class LoginDesktop extends React.Component<any, LoginState> {
    private recaptcha: RecaptchaProvider;
    private loginObservable: any = null;
    private userLogin: any = null;
    private adminDetailSubscription: any = null;
    private getTerminalsSubscription: any = null;
    private getDevelopersSubscription: Subscription | null = null;

    constructor(props: any) {
        super(props)
        this.state = {
            username: '',
            password: '',
            buttonDisabled: true,
            usernameProvided: false,
            loginError: false,
            showLoader: false,
            loginErrorMessage: "",
            superuserDetailsError: false,
            firstAttempt: true,
            loginOtherAttemptsButtonDisabled: false,
        };

        this.handleUsernameChanges = this.handleUsernameChanges.bind(this);
        this.handlePasswordChanges = this.handlePasswordChanges.bind(this);
        this.handleLoginFirstStep = this.handleLoginFirstStep.bind(this);
        this.handleModifyUser = this.handleModifyUser.bind(this);
        this.handleLogin = this.handleLogin.bind(this);

        this.recaptcha = RecaptchaProvider.getInstance();
    }

    componentDidMount() {
        this.setState({ firstAttempt: true });
        setTimeout(() => {
            GoogleTagManagerService.getInstance().pushPageAuthEvent(window.location.pathname, 'Login', null, 'username e password');
        }, 1000);
    }

    // Handlers
    private handleUsernameChanges(event: any) {
        this.setState({ loginError: false });
        this.setState({ username: event.target.value });
        this.setState({ buttonDisabled: !event.target.value });
    }

    private handlePasswordChanges(event: any) {
        this.setState({ loginError: false });
        this.setState({ password: event.target.value });
        this.setState({ buttonDisabled: !event.target.value });
        if (!this.state.firstAttempt) {
            this.setState({ loginOtherAttemptsButtonDisabled: !event.target.value });
        }
    }

    private handleLoginFirstStep(event: any) {
        console.log("[Login][handleLoginFirstStep] go to second step");
        event.preventDefault();
        this.setState({ usernameProvided: true });
        this.setState({ buttonDisabled: true });
    }

    private handleModifyUser(event: any) {
        console.log("[Login][handleModifyUser] modify user previously inserted!");
        event.preventDefault();
        this.setState({ usernameProvided: false });
        this.setState({ buttonDisabled: !this.state.username });
    }

    private goToRequestDev() {
        GoogleTagManagerService.getInstance().pushCta("richiedi utenza sviluppatore", "MuiButtonBase-root MuiButton-root MuiButton-text", "/activateDev");
        this.props.history.push("/registerDev");
    }

    private handleLogin(event: any) {
        console.log("[Login][handleLogin] do Login!");
        event.preventDefault();
        this.setState({ showLoader: true });
        this.recaptcha.getToken('login').then((recaptchaToken) => {
            console.log("[Login][handleLogin] recaptcha token: " + recaptchaToken);
            this.loginObservable = AuthService.getInstance().login(this.state.username, this.state.password, recaptchaToken).subscribe(result => {
                if (result === LoginApiState.LOGIN_SUCCESS) {
                    console.log("[Login][handleLogin] Login OK");

                    this.adminDetailSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                        this.setState({ showLoader: false });
                        this.setState({ superuserDetailsError: false });
                        this.goToHomePage();

                        // Get Terminals
                        this.getTerminalsSubscription = MposWebPortalApi.getInstance().getTerminals().subscribe((terminalsDto: ITerminalsDto) => {
                            StateContextProvider.getInstance().setProp('sameTerminalsType', TerminalsUtils.checkSameTerminalType(terminalsDto?.terminals))
                            StateContextProvider.getInstance().setProp('allTerminalsType', terminalsDto?.terminals?.length !== 0 ? terminalsDto?.terminals![0].terminalType : "")

                            const mPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "MPOS");
                            const mPosActive = mPos?.filter((element: any) => element.tidStatus === "ATTIVO");
                            const sPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "SOFTPOS");
                            const sPosActive = sPos?.filter((element: any) => element.tidStatus === "ATTIVO");
                            this.getDevelopersSubscription = MposWebPortalApi.getInstance().getDevelopers().subscribe((result) => {
                                details.numberOfDevs = result.developers!.length
                                GoogleTagManagerService.getInstance().pushPageLogin(
                                    'login',
                                    {
                                        result: 'ok',
                                        message: null
                                    },
                                    details.contractCode,
                                    {
                                        total: mPos?.length,
                                        active: mPosActive?.length
                                    },
                                    {
                                        total: sPos?.length,
                                        active: sPosActive?.length
                                    },
                                    { total: details.numberOfUsers },
                                    details.numberOfDevs
                                );
                            }, (error) => {
                                console.log(error)
                            });
                        }, (error) => {
                            console.log("[Terminals] Error when try to fetch data! " + JSON.stringify(error));
                            StateContextProvider.getInstance().setProp('sameTerminalsType', false)
                        });
                    }, () => {
                        this.setState({ superuserDetailsError: true });
                        this.setState({ showLoader: false });
                    });
                } else if (result === LoginApiState.LOGIN_DEVELOPER_SUCCESS) {
                    // User Login
                    this.userLogin = MposWebPortalApi.getInstance().userLogin().subscribe((payload: any) => {
                        StateContextProvider.getInstance().setProp('certificate', payload.certificate);
                    }, () => { });
                    this.setState({ showLoader: false });
                    this.goToHomePage();
                } else if (result === LoginApiState.LOGIN_CHANGE_PASSWORD) {
                    this.setState({ showLoader: false });
                    this.goToChangePasswordPage();
                } else if (result === LoginApiState.LOGIN_SUCCESS_WITH_SHOW_TC) {
                    console.log("[Login][handleLogin] Handle accept t&c...");
                    this.adminDetailSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                        this.setState({ showLoader: false });
                        this.setState({ superuserDetailsError: false });
                        this.goToHomePage();

                        // Get Terminals
                        this.getTerminalsSubscription = MposWebPortalApi.getInstance().getTerminals().subscribe((terminalsDto: ITerminalsDto) => {
                            StateContextProvider.getInstance().setProp('sameTerminalsType', TerminalsUtils.checkSameTerminalType(terminalsDto?.terminals))
                            StateContextProvider.getInstance().setProp('allTerminalsType', terminalsDto?.terminals?.length !== 0 ? terminalsDto?.terminals![0].terminalType : "")

                            const mPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "MPOS");
                            const mPosActive = mPos?.filter((element: any) => element.tidStatus === "ATTIVO");
                            const sPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "SOFTPOS");
                            const sPosActive = sPos?.filter((element: any) => element.tidStatus === "ATTIVO");

                            GoogleTagManagerService.getInstance().pushPageLogin(
                                'login',
                                {
                                    result: 'ok',
                                    message: null
                                },
                                details.contractCode,
                                {
                                    total: mPos?.length,
                                    active: mPosActive?.length
                                },
                                {
                                    total: sPos?.length,
                                    active: sPosActive?.length
                                },
                                { total: details.numberOfUsers },
                                details.numberOfDevs
                            );
                        }, (error) => {
                            console.log("[Terminals] Error when try to fetch data! " + JSON.stringify(error));
                            StateContextProvider.getInstance().setProp('sameTerminalsType', false)
                        });
                    }, () => {
                        this.setState({ superuserDetailsError: true });
                        this.setState({ showLoader: false });
                    });
                } else {
                    console.log("[Login][handleLogin] Login KO");
                    this.setLoginError();
                    this.setState({ loginErrorMessage: "Credenziali non corrette. Riprova" });
                    this.setState({ showLoader: false });
                    this.setState({ password: "" });
                    this.setState({ username: "" });
                    this.setState({ firstAttempt: false }, () => {
                        this.setState({ loginOtherAttemptsButtonDisabled: true });
                    });
                }
            }, error => {
                this.setState({ loginErrorMessage: "Il servizio non è disponibile. Riprova più tardi." });
                console.log("[Login][handleLogin] Login error: " + JSON.stringify(error));
                this.setLoginError();
                this.setState({ showLoader: false });
                this.setState({ password: "" });
                this.setState({ username: "" });
                this.setState({ firstAttempt: false }, () => {
                    this.setState({ loginOtherAttemptsButtonDisabled: true });
                });
            });
        }).catch(error => {
            console.log("[Login][handleLogin] recaptcha error: " + JSON.stringify(error));
            this.setState({ loginErrorMessage: "Il servizio non è disponibile. Riprova più tardi." });
            this.setLoginError();
            this.setState({ showLoader: false });
            this.setState({ password: "" });
            this.setState({ username: "" });
            this.setState({ firstAttempt: false }, () => {
                this.setState({ loginOtherAttemptsButtonDisabled: true });
            });
        });
    }

    private setLoginError() {
        this.setState({ loginError: true })
        this.setState({ buttonDisabled: true })
    }

    private goToHomePage() {
        this.props.history.push('/');
    }

    private goToChangePasswordPage() {
        this.props.history.push('/changePassword');
    }

    private goToTermsAndCondition() {
        this.props.history.push('/termsAndConditions', { fromHome: false });
    }

    componentWillUnmount() {
        if (this.loginObservable != null) {
            this.loginObservable.unsubscribe();
        }

        if (this.adminDetailSubscription != null) {
            this.adminDetailSubscription.unsubscribe();
        }

        if (this.getDevelopersSubscription != null) {
            this.getDevelopersSubscription.unsubscribe();
        }
    }

    render() {
        return (
            this.state.superuserDetailsError ? <ServiceUnavailablePage /> : <div id={"main-container-login"}>
                <img src={loginImage} alt="nexi pos" className={"login-desktop-image"} />
                <div className={"form-login-box-container"}>
                    <div className={"form-login-box-content"}>
                        <div className={this.state.loginError ? "margin-bottom-error title-box" : "title-box"}>
                            <Media query="(max-width: 1064px)" render={() =>
                            (<div className={"help-icon-container"}>
                                <a href={"/"}><HelpIcon className={"help-icon"} /></a>
                            </div>
                            )}
                            />
                            <h4 className={"form-title"}>Area riservata</h4>
                            <p className={"form-subtitle"}>Gestione Nexi POS</p>
                            {this.state.loginError &&
                                <p className={"error-msg-login-failed"}>{this.state.loginErrorMessage}</p>}
                        </div>
                        {
                            [this.state.firstAttempt && <div className={"form-content"}>
                                {(!this.state.usernameProvided || this.state.loginError) &&
                                    <form onSubmit={this.handleLoginFirstStep}>
                                        <div className={"form-elements"}>
                                            {(!this.state.usernameProvided
                                                || (this.state.usernameProvided && this.state.loginError))
                                                && <TextField id="usernameField" label="Inserisci username Nexi POS"
                                                    className={this.state.loginError ? "margin-bottom-error-double" : ""}
                                                    onChange={this.handleUsernameChanges} value={this.state.username}
                                                    error={this.state.loginError} />}
                                            {!this.state.loginError && <Button className={"submit-button"} type={"submit"}
                                                disabled={this.state.buttonDisabled}>AVANTI</Button>}
                                            <div className="box-text-credentials">
                                                <p>
                                                    Non ricordi le tue credenziali? Recuperale dall’App Nexi POS.
                                                </p>
                                            </div>
                                        </div>
                                    </form>}
                                {
                                    this.state.usernameProvided && <div>
                                        {!this.state.loginError && <div>
                                            <p className={"username-field-title"}>Username Nexi POS</p>
                                            <p className={"username-field-value"}>{StringUtils.maskString(this.state.username!!)}</p>
                                            <Button id={"button-change"}
                                                onClick={this.handleModifyUser} disableRipple>MODIFICA</Button>
                                        </div>}
                                        <form onSubmit={this.handleLogin}>
                                            <div className={"form-elements form-elements-margin"}>
                                                <TextField id={"passwordField"} label="Inserisci la tua password" type={"password"}
                                                    onChange={this.handlePasswordChanges}
                                                    value={this.state.password} error={this.state.loginError} />
                                                <div className="box-text-credentials">
                                                    <p>
                                                        Non ricordi le tue credenziali? Recuperale dall’App Nexi POS.
                                                    </p>
                                                </div>
                                                <Button className={"submit-button submit-button-after-username"}
                                                    type={"submit"}
                                                    disabled={this.state.buttonDisabled}>AVANTI</Button>
                                                {
                                                    // @ts-ignore
                                                    <MposLoader show={this.state.showLoader} />
                                                }
                                            </div>
                                        </form>
                                    </div>
                                }
                            </div>,
                            !this.state.firstAttempt && <div className={"form-content"}>
                                <form onSubmit={this.handleLogin}>
                                    <div className={"form-elements"}>
                                        <TextField id="usernameField" label="Inserisci username Nexi POS"
                                            className={this.state.loginError ? "margin-bottom-error-double" : ""}
                                            onChange={this.handleUsernameChanges} value={this.state.username}
                                            error={this.state.loginError} />
                                    </div>
                                    <div className={"form-elements form-elements-margin"}>
                                        <TextField id={"passwordField"} label="Inserisci la tua password" type={"password"}
                                            onChange={this.handlePasswordChanges}
                                            value={this.state.password} error={this.state.loginError} />
                                        <Button className={"submit-button submit-button-after-username"}
                                            type={"submit"}
                                            disabled={this.state.loginOtherAttemptsButtonDisabled}>AVANTI</Button>
                                        {
                                            // @ts-ignore
                                            <MposLoader show={this.state.showLoader} />
                                        }
                                    </div>
                                </form>
                            </div>]
                        }
                    </div>
                    <p className="registerDev">Devi accedere all’area sviluppatore? <Button disableRipple onClick={() => {
                        this.goToRequestDev();
                    }} className="registerDevUser">Richiedi account sviluppatore</Button></p>

                </div>
            </div>
        );
    }
}